<template>
    <div id="verify-camp" class="verify-camp d-flex flex-column justify-content-center mx-auto">
        <div class="d-flex flex-column align-items-center">
            <div>
                <img :src="ICON_VERIFIED"
                    alt="">
            </div>
            <div>
                <p class="c7 h4b mt-3">Verify Your Campaign</p>
            </div>
            <div class="text-center">
                <p class="mb-0 p1n c7">
                    Confirm the ownership <br>
                    to avoid possible fraudulent actions <br>
                    with your project.
                </p>
            </div>
        </div>
        <div class="d-flex justify-content-center mt-4">
            <div class="step text-center px-4 py-4 d-flex flex-column">
                <div class=" my-auto">
                    <p class="p1n c6">Invite <b>team@crossprom.com</b> with Manage community permission in Kickstarter</p>
                </div>
                <div class="mt-auto">
                    <button id="invite-button" @click="invite" class="p2b c1 mx-auto">
                        Invite
                    </button>
                </div>
            </div>

        </div>
        <BannerModal :project-url="projectUrl"/>
    </div>
</template>

<script>
    import { getDataByDocId, getRef } from "../../firebaseCRUD";
    import BannerModal from '../../popups/BannerModal.vue'
    import {DEFAULT_CAMPAIGN_COLLECTION} from "../../firebase";
    import {ICON_VERIFIED} from "../../constants";
    import {mapGetters} from 'vuex'

    export default {
        name: "VerifyCamp",
        components: {
            BannerModal
        },
        props: {
          cardData: Object
        },
        data() {
            return {
                inviteUrl: null,
                ICON_VERIFIED
            }
        },
        computed:{
            projectUrl(){
                return this.cardData ? 
                    `${window.location.origin}/campaigns/${this.$route.query.id}?utm_source=banner&utm_medium=${this.cardData.title}&utm_campaign=prm` : ''
            },
        },
        watch: {
            'disabled': 'checkCampVerification',
            '$route.query.id': 'checkCampVerification'
        },
        mounted() {
            this.checkCampVerification();
        },
        methods: {
            async getProjectLinkFromFirebase() {
                let projectUrl = '';
                if(this.cardData && this.cardData.project_url){
                    projectUrl = this.cardData.project_url;
                } else {
                    const doc = await getDataByDocId({
                        collection: DEFAULT_CAMPAIGN_COLLECTION,
                        id: this.$route.query.id
                    });
                    if(!doc.exists){
                        this.$router.push('/404');
                        return ;
                    }
                    projectUrl = doc.data().project_url
                }

                this.inviteUrl = projectUrl.split('?')[0] + '/collaborators?ref=creator_nav'
            },
            invite: function() {
                this.$bvModal.show('banner-modal')
                this.$ga.event('Add Wizard', 'Invite Button Click', 'Step', 5)
                this.$sendMixpanelEvent('Add Wizard', {
                    'Step Number': 5,
                    'Action': 'Invite Button Clicked'
                });
                window.open(this.inviteUrl, "_blank");

            },
            async checkCampVerification() {
                const campaignsRef = await getRef({
                    collection: 'campaigns',
                    id: this.$route.query.id
                });
                const unsubscribe = campaignsRef.onSnapshot(querySnapshot => {
                    if (querySnapshot.exists) {
                        this.$store.commit('TOGGLE_MODAL', ['camp-success', true])
                        unsubscribe()
                    }
                })
            }
        },
        created() {
            if(this.$route.query.id) {
                this.getProjectLinkFromFirebase()
            }
        }
    }
</script>

<style scoped lang="scss">
    div.verify-camp {
        width: 530px;
        height: 523px;

        div.step {
            width: 246px;
            height: 248px;
            background: #FFFFFF;
            box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.06);
            border-radius: 6px;

            button {
                width: 122px;
                height: 35px;
                border: 1px solid #727CF5;
                border-radius: 5px;
                text-align: center;
                transition: all 0.3s ease;

                &:focus {

                    border: 1px solid #727CF5 !important;
                }
                &:hover {
                    border: 1px solid #727CF5;
                    background: #727CF5;
                    color: #ffffff !important;
                }
            }
        }
    }
</style>